import * as React from 'react';

import { overview } from '@/data/starting-steps';

import { Button } from '../ui/Button';

import { StepCard } from './StepCard';

export const StartingSteps = React.memo(({ onClick, ctaText }: { onClick?: () => void; ctaText?: string }) => {
  return (
    <>
      <div className='max-w-8xl mx-auto px-6 md:px-12 gap-8 sm:gap-12 lg:gap-x-20 grid sm:grid-cols-2 lg:grid-cols-4 mt-4'>
        {overview.map((item, index) => (
          <StepCard copy={item.copy} heading={item.heading} key={item.heading} step={index + 1} />
        ))}
      </div>

      <div className='w-full flex justify-center'>
        <Button className='mt-6 self-center' onClick={onClick} variant='primary'>
          {ctaText}
        </Button>
      </div>
    </>
  );
});

StartingSteps.displayName = 'StartingSteps';
